module.exports = __webpack_public_path__ + "static/more-features-released-e553b5ae7d581b7e81046dc0e8869295.svg";